import { render, staticRenderFns } from "./wrongQuest.vue?vue&type=template&id=7f2eef05&scoped=true&"
import script from "./wrongQuest.vue?vue&type=script&lang=js&"
export * from "./wrongQuest.vue?vue&type=script&lang=js&"
import style0 from "./wrongQuest.vue?vue&type=style&index=0&id=7f2eef05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2eef05",
  null
  
)

export default component.exports